import { Badge } from "../TextBadge";

interface VariantCountBadgeProps {
  count: string;
}

export const VariantCountBadge = ({ count }: VariantCountBadgeProps) => {
  return (
    <Badge variant="light" size="medium" position="bottomLeft">
      {`Available in ${count} variants`}
    </Badge>
  );
};
